import React, { Component } from "react";
import profile from "../../assets/profile.png";
import Title from "./Title";

class About extends Component {
  state = {
    dispalyBio: false
  };

  toggleDisplayBio = () => {
    this.setState({ dispalyBio: !this.state.dispalyBio });
  };
  render() {
    return (
      <div>
        <img src={profile} alt="profile" className="profile" />
        <h1>Hello!</h1>
        <p>My name is Isheal. </p>
        <Title />
        <p>I'm a self-motivated learner and illustrate every day.</p>
        {this.state.dispalyBio ? (
          <div>
            <p>I'm interested in concept arts and environment design.</p>
            <p>
              I'm passionate about learning the latest technologies whether that
              is illustration or design.
            </p>
            <p>Besides working, I'm fond of working-out.</p>
            <p>
              I am now trying to be a blogist on fashion and gourmet.
            </p>
            <p>Feel free to look around my site and contact me!</p>
            <button
              className="btn btn-outline-success"
              onClick={this.toggleDisplayBio}
            >
              Show Less
            </button>
          </div>
        ) : (
          <div>
            <button
              className="btn btn-outline-success"
              onClick={this.toggleDisplayBio}
            >
              Read More...
            </button>
          </div>
        )}
        <hr />
      </div>
    );
  }
}

export default About;
